import React, { useCallback, useRef, useState, useEffect } from 'react'
import FeedItem from './item'
import { ICommonContentRankItem, getPGCArticleRank } from '../../services/home'
import FloorTabTitle from 'Components/floor/floor-tab-title'
import CommonTopTextCard from '../common-top-text-card'
import Statement from 'Components/statement-new'
import FriendshipLink, { IFriendshipLinkData } from '../friendship-link'
import ScrollLoader from 'Components/scroll-loader'
import Loading from 'Components/loading'
import fetchFeed, { IFeedData, IParams } from 'lib/fetch-feed'
import { useResponsive } from 'Components/hooks/use-responsive'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useInView } from 'react-intersection-observer'
import StickyNav from 'Components/new/sticky-nav'
import classNames from 'classnames'

interface IProps {
  friendshipLinkData: IFriendshipLinkData[]
  articlePGCRankData: ICommonContentRankItem[]
}

export const tabs = [
  {
    id: 'motor_car',
    label: '推荐',
  },
  {
    id: 'motor_car_new_arrival',
    label: '新车',
  },
  {
    id: 'motor_local',
    label: '本地',
  },
  {
    id: 'motor_car_new_guide',
    label: '导购',
  },
  {
    id: 'motor_car_suv',
    label: 'SUV',
  },
  {
    id: 'motor_industry',
    label: '行业',
  },
  {
    id: 'motor_car_new_energy',
    label: '新能源',
  },
  {
    id: 'motor_car_motorcycle',
    label: '摩托车',
  },
  {
    id: 'motor_car_independent_brand',
    label: '中国品牌',
  },
  {
    id: 'motor_car_use',
    label: '用车',
  },
  {
    id: 'motor_car_evaluating',
    label: '试车',
  },
  {
    id: 'motor_car_trail_diary',
    label: '提车作业',
  },
  {
    id: 'motor_car_travel',
    label: '自驾游',
  },
  {
    id: 'motor_car_offroad',
    label: '越野',
  },
  {
    id: 'motor_car_modification',
    label: '改装',
  },
]

const HomeFeed: React.FC<IProps> = ({
  friendshipLinkData,
  articlePGCRankData = [],
}) => {
  const conditionRef = useRef<{
    id: string
    fetchId: number
    initLoading: boolean
  }>()
  const loadCacheRef = useRef<{ [key: string]: any }>({})
  const timerRef = useRef<any>()
  const [loading, setLoading] = useState(false)
  const [videoList, setVideoList] = useState<IFeedData[]>([])
  const responsive = useResponsive()
  const [ref, inView] = useInView({
    threshold: 0,
  })
  const [refRelate, inViewRelate] = useInView({
    threshold: 0,
  })

  useEffect(() => {
    if (inView) {
      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'feed_module',
      })
      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'group_rank_module',
      })
    }
  }, [inView])

  useEffect(() => {
    if (inViewRelate) {
      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'related_module',
      })
    }
  }, [inViewRelate])

  const handleChange = useCallback((id, isIinit) => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(async () => {
      if (!isIinit) {
        sendTeaCommEvent('hover_event', {
          page_id: 'page_main_new',
          event_id: 'feed_module_nav',
          module_id: 'feed_module',
          button_name: id,
        })
      }

      const fetchId = Math.random()
      conditionRef.current = { id, fetchId, initLoading: true }
      setLoading(false)

      const cacheData = loadCacheRef?.current[conditionRef?.current?.id]
      if (cacheData) {
        setVideoList(cacheData)
        conditionRef.current.initLoading = false
        return
      }

      setLoading(true)
      setVideoList([])
      //conditionRef.current.initLoading = true;
      const playLoad: IParams = {
        tt_from: 'enter_auto',
        category: conditionRef?.current?.id,
        count: 24,
      }

      //feed 接口用的mobile的，无法支持分页，且每次请求参数依赖上次behot_time字段，只有串行加载, 待后端优化
      const result = await fetchFeed(playLoad)
      result.data = result?.data.filter((item: IFeedData) => !item.duplicate)

      if (conditionRef?.current?.fetchId !== fetchId) {
        return
      }
      setLoading(false)
      setVideoList(result.data)
      conditionRef.current.initLoading = false

      if (conditionRef?.current?.id && loadCacheRef?.current) {
        loadCacheRef.current[conditionRef?.current?.id] = result.data
      }
    }, 200)
  }, [])

  /* 懒加载 */
  const loadMoreHandler = () => {
    if (
      !conditionRef?.current?.id ||
      loading ||
      conditionRef.current.initLoading
    ) {
      return
    }
    setLoading(true)

    fetchFeed({
      tt_from: 'load_more',
      category: conditionRef?.current?.id,
      count: 20,
      max_behot_time: videoList?.[videoList?.length - 1]?.info?.behot_time,
    })
      .then((res) => {
        const list = res?.data?.filter((item: IFeedData) => !item.duplicate)
        const newList = videoList?.concat(list)
        setVideoList(newList)

        if (
          conditionRef?.current?.id &&
          loadCacheRef.current[conditionRef?.current?.id]
        ) {
          loadCacheRef.current[conditionRef?.current?.id] = newList
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className="home-feed-card tw-mt-16" ref={ref}>
      <div className="tw-grid tw-grid-cols-40 tw-gap-12">
        <div className="tw-col-span-30 2xl:tw-col-span-32">
          <StickyNav
            height={40}
            renderContent={(isFixed) => {
              return (
                <FloorTabTitle
                  className={classNames({
                    'tw-mt-30': isFixed,
                  })}
                  isFixed={isFixed}
                  onTitleClick={() => 0}
                  navList={tabs.map((item) => ({
                    link: item.id,
                    label: item.label,
                  }))}
                  onChange={handleChange}
                />
              )
            }}
          />
          <ScrollLoader
            loading={loading}
            loadMoreHandler={loadMoreHandler}
            end={false}
          >
            <div className="tw-grid tw-grid-cols-30 2xl:tw-grid-cols-32 tw-gap-x-12 tw-gap-y-38">
              {videoList?.map((item: any, index: number) => {
                return (
                  <div className="tw-col-span-10 2xl:tw-col-span-8" key={index}>
                    <FeedItem
                      order={index}
                      category={conditionRef?.current?.id || ''}
                      uniqueIdStr={item.unique_id_str}
                      title={item?.info?.title}
                      coverUrl={item?.info.repost_info?.image_url}
                      duration={item?.info?.video_duration}
                      avatar={item?.info?.user_info?.avatar_url}
                      name={item?.info?.user_info?.name}
                      publishTime={item?.info?.publish_time}
                      videoWatchCount={
                        item?.info?.video_detail_info?.video_watch_count ||
                        item?.info?.read_count
                      }
                      userId={item?.info?.user_info?.user_id}
                      userVerified={
                        item?.info?.user_info?.user_verified ||
                        !!item?.info?.user_info?.motor_auth_show_info
                          ?.auth_v_type
                      }
                      verifyType={
                        item?.info?.user_info?.motor_auth_show_info?.auth_v_type
                      }
                      authorTeaParams={{
                        page_id: 'page_main_new',
                        event_id: 'feed_module_profile',
                        module_id: 'feed_module',
                      }}
                      contentTeaParams={{
                        page_id: 'page_main_new',
                        event_id: 'feed_module_group',
                        module_id: 'feed_module',
                      }}
                    />
                  </div>
                )
              })}
            </div>
            {loading ? <Loading /> : null}
          </ScrollLoader>
        </div>
        <div className="tw-col-span-10 2xl:tw-col-span-8">
          <div>
            <FloorTabTitle
              title="文章排行榜"
              onTitleClick={() => {
                sendTeaCommEvent('clk_event', {
                  page_id: 'page_main_new',
                  event_id: 'group_rank_module_title',
                  module_id: 'group_rank_module',
                  module_title: '文章排行榜',
                })
              }}
            />
            <CommonTopTextCard
              teaParams={{
                page_id: 'page_main_new',
                event_id: 'group_rank_module_item',
                module_id: 'group_rank_module',
              }}
              list={articlePGCRankData?.map((item) => ({
                id: item?.group_id,
                link: `/article/${item?.group_id}`,
                title: item?.title,
                viewCount: item?.count,
              }))}
            />
          </div>
          <div className="tw-mt-8" ref={refRelate}>
            <FloorTabTitle title="友情链接" onTitleClick={() => 0} />
            <FriendshipLink />
          </div>
          <Statement />
        </div>
      </div>
    </div>
  )
}

export default HomeFeed
